export class JobStatistics{

    Id:number;
    UserId:number;
    JobId:number;
    TotalViews:number;
    TotalApplications:number;
    CreatedOn: Date;
    FirstName: string;
    LastName: string;
    IsChecked: boolean;
}